import { IsNotEmpty, IsUUID, IsString, MinLength, MaxLength } from 'class-validator';

export class RouteTradeRequestAttestActionDTO {

    @IsNotEmpty()
    @IsUUID()
    requestId: string;

    @IsNotEmpty()
    @IsString()
    @MinLength(6)
    @MaxLength(7)
    action: string;

}
